module.exports = __webpack_public_path__ + "static/fence-9839384862cb831ae4d3294fe5e8031f.png";